var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 23,
    viewBox: "0 0 20 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6198 7.45C17.7458 2.79349 13.5398 0.75 9.99981 0.75C9.99981 0.75 9.99981 0.75 9.98981 0.75C6.45981 0.75 2.4198 2.82 1.36981 7.44C-0.361042 15.0558 9.99981 21.25 9.99981 21.25C9.99981 21.25 20.1248 15.4688 18.6198 7.45ZM9.99981 12.46C8.25981 12.46 6.84981 11.05 6.84981 9.31C6.84981 7.57 8.25981 6.16 9.99981 6.16C11.7398 6.16 13.1498 7.57 13.1498 9.31C13.1498 11.05 11.7398 12.46 9.99981 12.46Z",
    stroke: "#DFDAD4",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationPin);
export default __webpack_public_path__ + "static/media/locationPin.29682b69db6666c71cdae8e701fe9834.svg";
export { ForwardRef as ReactComponent };